import { useState, useEffect, useMemo } from "react";

import { usePageLanguage } from "../../common/usePageLanguage";
import { usePageCountry } from "../../common/usePageCountry";
import { usePageName } from "../../common/usePageName";
import { usePageType } from "../../common/usePageType";
import { usePageCategory } from "../../common/usePageCategory";
import { usePageSubcategory } from "../../common/usePageSubcategory";
import { browserHistory } from "../../../../routes/history";

export function useUtagDataScript() {
  const [pathname, setPathname] = useState(location.pathname);
  useEffect(() => {
    const unreg = browserHistory.listen(location => {
      setPathname(location.pathname);
    });

    return () => unreg();
  }, []);

  const language = usePageLanguage();
  const country = usePageCountry();
  const pageName = usePageName(pathname);
  const pageType = usePageType(pathname);
  const pageCategory = usePageCategory(pathname);
  const pageSubcategory = usePageSubcategory(pathname);

  const utag_data = useMemo(() => ({
    page_language: language,
    page_country: country,
    page_name: pageName,
    page_category: pageCategory,
    page_subcategory: pageSubcategory,
    page_type: pageType,
    platform: navigator.platform,
    user_agent: navigator.userAgent,
  }), [language, country, pageName, pageCategory, pageSubcategory, pageType]);

  return utag_data;
}
